// extracted by mini-css-extract-plugin
export default {"cross":"CrossForModal_cross__+H-ql"};